module.exports = {"wp_api_path":"/wp-json/wp/v2/","acf_api_path":"/wp-json/acf/v3/","kookvue_api_path":"/wp-json/kookvue/v1/","template_scripts":{"category":"./src/js/category.js","posts":"./src/js/posts.js","page":"./src/js/page-template.js","single":"./src/js/single-post.js"}}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 7
// module chunks = 0 1 2 3